export default "__VITE_ASSET__BdSvVW5K__"